var _path, _path2, _path3, _circle, _circle2, _path4, _polygon, _rect, _path5, _circle3, _rect2, _path6, _circle4, _rect3, _path7, _circle5, _rect4, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle6, _path17, _path18, _path19, _path20, _path21, _path22, _circle7, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFarms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a3fec48f-3481-4190-9b24-b4f8cfdaa861",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 888,
    height: 677.20707,
    viewBox: "0 0 888 677.20707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "walking_outside") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1043.6747,508.0556A98.57952,98.57952,0,1,0,854.45407,546.865c-.0964-.10719-.196-.21147-.29192-.31907a98.666,98.666,0,0,0,17.95428,27.78281c.02242.02466.04544.04871.0679.07338.6056.66,1.21467,1.3166,1.8378,1.9599a98.28015,98.28015,0,0,0,69.52936,30.25355L940.2204,787.54475h10.29127l-2.08284-119.41539,14.88675-7.83759-2.27095-4.31351-12.711,6.692-.97788-56.06376A98.57817,98.57817,0,0,0,1043.6747,508.0556Z",
    transform: "translate(-156 -111.39647)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M751.08711,460.00819a115.52648,115.52648,0,1,0-221.74983,45.4812c-.113-.12561-.22968-.24782-.34211-.37392a115.62781,115.62781,0,0,0,21.04083,32.559c.02627.02891.05325.05709.07957.086.70971.7735,1.42348,1.54294,2.15374,2.29683a115.1756,115.1756,0,0,0,81.48225,35.45448l-3.90373,212.033h12.06045l-2.44091-139.94427,17.446-9.185-2.66136-5.05506-14.89615,7.84247-1.146-65.70176A115.5249,115.5249,0,0,0,751.08711,460.00819Z",
    transform: "translate(-156 -111.39647)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M419.2589,414.81471A131.46682,131.46682,0,1,0,166.912,466.5714c-.12856-.14294-.26138-.282-.38931-.42552a131.58182,131.58182,0,0,0,23.944,37.05149c.02989.03289.06059.065.09055.09786.80763.88023,1.61989,1.75584,2.45091,2.61375a131.0676,131.0676,0,0,0,92.72517,40.34649L281.291,787.54475h13.72455L292.23788,628.291,312.091,617.83868l-3.02857-5.75256-16.95153,8.92457-1.30412-74.76729A131.465,131.465,0,0,0,419.2589,414.81471Z",
    transform: "translate(-156 -111.39647)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 756.68549,
    cy: 85.97574,
    r: 85.97574,
    fill: "#ff6584"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.55884,
    cy: 187.61627,
    r: 172.31169,
    fill: "#76de72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M274.32944,183.92206A172.32513,172.32513,0,0,0,561.45166,366.29171,172.32654,172.32654,0,1,1,274.32944,183.92206Z",
    transform: "translate(-156 -111.39647)",
    opacity: 0.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "246.032 187.616 246.506 187.616 255.027 676.148 237.038 676.148 246.032 187.616",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 412.92005,
    y: 552.74643,
    width: 8.52091,
    height: 32.1901,
    transform: "translate(570.17726 -176.70103) rotate(62.23413)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M665.11522,782.975s.62169-13.02675,13.36641-11.51257",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 505.51414,
    cy: 652.80329,
    r: 6.37864,
    fill: "#76de72"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 504.47624,
    y: 663.54454,
    width: 1.80054,
    height: 12.60377,
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.08289,781.17442s.62169-13.02675,13.36641-11.51256",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.48181,
    cy: 651.00275,
    r: 6.37864,
    fill: "#76de72"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.44391,
    y: 661.744,
    width: 1.80054,
    height: 12.60377,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M327.51415,782.07469s.6217-13.02675,13.36642-11.51256",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.91308,
    cy: 651.90302,
    r: 6.37864,
    fill: "#76de72"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 166.87518,
    y: 662.64427,
    width: 1.80054,
    height: 12.60377,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M605.24329,194.695l12.79484-10.23342c-9.93974-1.09662-14.02379,4.3243-15.69523,8.615-7.76533-3.22445-16.21882,1.00136-16.21882,1.00136l25.6001,9.29374A19.3721,19.3721,0,0,0,605.24329,194.695Z",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M799.827,298.93628l12.79483-10.23342c-9.93974-1.09662-14.02379,4.3243-15.69523,8.615-7.76533-3.22445-16.21881,1.00135-16.21881,1.00135l25.6001,9.29375A19.37224,19.37224,0,0,0,799.827,298.93628Z",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M589.95458,387.88881l12.79483-10.23342c-9.93974-1.09662-14.02379,4.3243-15.69523,8.615-7.76533-3.22445-16.21881,1.00136-16.21881,1.00136l25.6001,9.29374A19.37224,19.37224,0,0,0,589.95458,387.88881Z",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M515.25534,729.27564s10.02117,29.34773,5.72638,40.0847l12.88437,11.45277,7.87378-10.02118s-8.58958-8.58957-7.87378-15.03176,1.43159-29.34772,1.43159-29.34772Z",
    transform: "translate(-156 -111.39647)",
    fill: "#ffb9b9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M563.20986,786.53557c-.58519.34211-1.14336.66619-1.65652.9633H517.12507a2.34481,2.34481,0,0,1-1.15232-2.39475c.207-1.06231.73817-3.22293,1.39541-5.70768,1.55744-5.87878,3.84411-13.57608,4.3393-12.75686a.00881.00881,0,0,1,.009.009c.69322,1.27843,2.12468,7.00413,5.70773,6.29288,3.58306-.72021,9.30881-2.1516,9.30881-2.1516s-2.04363-4.59141-.09006-6.446a2.7381,2.7381,0,0,1,1.52146-.7112c4.2943-.71119,4.2943,5.7257,4.2943,5.7257l15.74571,8.58861a26.15485,26.15485,0,0,1,3.9612,1.44942C565.36152,780.89086,568.52148,783.44765,563.20986,786.53557Z",
    transform: "translate(-156 -111.39647)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M486.62341,718.53867l-18.61075,22.18974-5.01059,11.45277,6.44219,5.01059,5.72638-2.14739s5.01059-12.88437,10.02118-15.03176S502.371,723.54926,502.371,723.54926Z",
    transform: "translate(-156 -111.39647)",
    fill: "#ffb9b9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M525.63441,701.50981l-9.49149,17.59433-6.80008,12.59807c-2.176,1.29559-5.075,1.2741-8.1959.50819a31.39068,31.39068,0,0,1-4.26613-1.42443c-8.518-3.48594-17.1577-10.40769-17.1577-10.40769L496.072,699.94937l5.33982-6.66408,1.267-1.58905,6.10578,2.61264,10.77275,4.60258Z",
    transform: "translate(-156 -111.39647)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M483.27421,549.581l-7.58182,31.1003,7.8042,39.89975s.19224,16.31058,7.34388,15.07281-.34315-17.68773-.34315-17.68773l-3.49816-32.71568L498.18357,552.929a5.93875,5.93875,0,0,0-2.86235-7.03152h0C490.89281,543.19281,484.59952,545.11708,483.27421,549.581Z",
    transform: "translate(-156 -111.39647)",
    fill: "#ffb9b9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M509.88685,522.76789l-6.44218,20.04234-12.16857-6.44218s5.01059-14.316,5.01059-16.46336S509.88685,522.76789,509.88685,522.76789Z",
    transform: "translate(-156 -111.39647)",
    fill: "#ffb9b9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.87626,
    cy: 404.21344,
    r: 15.03176,
    fill: "#ffb9b9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M508.81315,547.46292,505.95,544.59973l-.7158-3.579s-9.30537-12.16857-17.17915-7.87378c-2.46056,1.34212-4.292,4.4318-5.64722,8.04574a39.08474,39.08474,0,0,0,.89905,29.07228l12.62195,29.4512,28.63192-2.86319-5.01058-18.61075s5.01058-11.45277-4.29479-19.32655Z",
    transform: "translate(-156 -111.39647)",
    fill: "#76de72"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M525.63441,701.50981l-9.49149,17.59433-6.80008,12.59807c-2.176,1.29559-5.075,1.2741-8.1959.50819-.544-3.62194,2.70574-22.76237.15033-38.36676l.11451-.55835,1.267-1.58905,6.10578,2.61264,10.77275,4.60258Z",
    transform: "translate(-156 -111.39647)",
    opacity: 0.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M525.63441,595.0635s-18.61075-11.45277-31.49512,2.86319l.7158,4.29479s-10.737,12.16857-4.29479,37.9373,16.46336,93.05375,16.46336,93.05375,23.62134,1.4316,34.35831-6.44218c0,0-3.579-88.759-15.74756-97.34854Z",
    transform: "translate(-156 -111.39647)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M486.82706,555.19609l20.1966,24.83565,36.5057,17.89495s13.11132,9.70389,16.44713,3.25793-14.29973-10.41591-14.29973-10.41591l-28.17964-16.98413-18.99238-28.44394a5.93875,5.93875,0,0,0-7.332-1.96888h0C486.34156,545.2655,484.07144,551.44245,486.82706,555.19609Z",
    transform: "translate(-156 -111.39647)",
    fill: "#ffb9b9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M473.44616,753.47183s4.38754-5.51807,7.00852-2.04129-3.09079,6.4563-3.09079,6.4563l-.33243,17.93477s3.11688,13.71345-5.29829,8.41516-8.74622-5.93293-10.4015-9.10613-5.07575-15.92095-8.02778-20.03238-5.65544-12.38922-2.15118-13.40987,19.83839-4.65445,19.02463-3.444-5.22876,5.12816-2.93884,7.9703S473.44616,753.47183,473.44616,753.47183Z",
    transform: "translate(-156 -111.39647)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M512.74865,502.78028c0-.01835.00139-.03639.00139-.05474a20.75815,20.75815,0,1,0-20.75814,20.75814c.48224,0,2.38917,3.61137,2.86319,3.579C494.88353,516.10547,501.97152,503.516,512.74865,502.78028Z",
    transform: "translate(-156 -111.39647)",
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 313.80216,
    cy: 375.58152,
    r: 13.60016,
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M469.17825,466.376a13.5814,13.5814,0,0,1,3.88007,26.62165,13.59039,13.59039,0,1,0-3.88007-26.62165Z",
    transform: "translate(-156 -111.39647)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M345.29727,387.03429h7.158a12.88435,12.88435,0,0,1,12.88435,12.88435v0a0,0,0,0,1,0,0H345.29727a0,0,0,0,1,0,0V387.03429A0,0,0,0,1,345.29727,387.03429Z",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M839.65525,787.70327s.6217-13.02675,13.36642-11.51257",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M719.91941,787.70327s.62169-13.02675,13.36641-11.51257",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M283.2887,787.70327s.62169-13.02675,13.36641-11.51257",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M893.67142,787.70327s.6217-13.02675,13.36642-11.51257",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M868.46388,787.70327s.62169-13.02675,13.36641-11.51257",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M816.46505,787.70327s-.62169-13.02675-13.36641-11.51257",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M609.40307,787.70327s-.6217-13.02675-13.36642-11.51257",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M437.45159,787.70327s-.62169-13.02675-13.36641-11.51257",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M254.69688,787.70327s-.6217-13.02675-13.36641-11.51257",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M947.9044,787.70327s-.62169-13.02675-13.36641-11.51257",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M870.48122,788.60353s-.62169-13.02674-13.36641-11.51256",
    transform: "translate(-156 -111.39647)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 674.60353,
    width: 888,
    height: 2,
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFarms);
export default __webpack_public_path__ + "static/media/no-farms.9465b7c65f7992e99cee2898aebe9b5c.svg";
export { ForwardRef as ReactComponent };